import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Skeleton from '@material-ui/lab/Skeleton';
import { Panel } from './shared';

const InsightsSkeleton = ({ tiles = 8, sections = 5, label = 'Loading platform insights' }) => (
  <div aria-label={label} aria-busy="true">
    <Skeleton width="18%" /><Skeleton width="45%" height={48} /><Skeleton width="70%" />
    <Typography variant="caption" color="textSecondary" role="status">
      Counting everything from scratch can take up to a minute. Later loads come from a 5-minute cache.
    </Typography>
    <Skeleton variant="rect" height={96} style={{ borderRadius: 16, marginTop: 24 }} />
    <Grid container spacing={2} style={{ marginTop: 8 }}>{Array.from({ length: tiles }).map((_, index) => <Grid item xs={12} sm={6} lg={3} key={index}><Panel><Skeleton width="55%" /><Skeleton width="45%" height={54} /><Skeleton width="80%" /></Panel></Grid>)}</Grid>
    {Array.from({ length: sections }).map((_, index) => <Skeleton key={index} variant="rect" height={220} style={{ borderRadius: 16, marginTop: 24 }} />)}
  </div>
);

export default InsightsSkeleton;
